export default {
  getDealers: (state) => {
    return state.dealers
  },
  getCurrentDealers: (state) => {
    return state.current_dealers
  }
}
